export enum KbArticleVariant {
  // Full document sizing (Home overlay).
  Document = "document",
  // Narrow host: container sizing off, tighter rhythm (mailbox column, right panel).
  Embedded = "embedded",
}
